<template>
    <div style="background-color: #fafafa;">
        <van-tabs v-model="selected" type="line" sticky @click="switchTab">
            <van-tab title="设备信息" >
                <van-cell-group>
                    <van-field v-model="data.productCode" readonly label="设备序列号" />
                    <van-field v-model="data.productModel" readonly label="设备型号" />
                    <van-field v-model="data.arrivalDate" readonly label="到货日期"/>
                    <van-field v-model="data.turnOnDate" readonly label="开机日期"/>
                    <van-field v-model="data.outInsuranceDate" readonly label="出保日期"/>
                    <van-field v-model="data.remark" readonly label="备注"/>
                    <van-cell title="设备安装图片" title-class="attachment-title">
                        <img v-for="(uuid,index) in equipmentImage" @click="showImagePreview(uuid)" :key="index" class="attachImg" :src="avatarUrl+uuid">
                    </van-cell>
                    <van-cell title="检查过程图片" title-class="attachment-title">
                        <img  v-for="(uuid,index) in examiningImage" @click="showImagePreview(uuid)" :key="index" class="attachImg" :src="avatarUrl+uuid">
                    </van-cell>
                    <van-cell title="开机调试图片" title-class="attachment-title">
                        <img  v-for="(uuid,index) in installedImage" @click="showImagePreview(uuid)" :key="index" class="attachImg" :src="avatarUrl+uuid">
                    </van-cell>
                    <van-cell title="服务报告" title-class="attachment-title">
                        <a v-for="(uuid,index) in reportList" :key="index" @click="downLoad(uuid)">服务报告{{index+1}}  </a>
                    </van-cell>
                    <van-cell title="其他附件" title-class="attachment-title">
                        <img v-for="(uuid,index) in attachmentIds" @click="showImagePreview(uuid)" :key="index" class="attachImg" :src="avatarUrl+uuid">
                    </van-cell>
                </van-cell-group>

            </van-tab>
            <van-tab title="元器件列表">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(1)">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
                        <div v-for="parts in list" class="card" :key="parts.uuid">
                            <table class="layout">
                                <tr>
                                    <td colspan="2">
                                        <div class="header">
                                            <span class="title">{{parts.name}}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="content">
                                        <p>
                                            <span>型号：</span>
                                            <span>{{parts.model}}</span>
                                        </p>
                                        <p>
                                            <span>数量：</span>
                                            <span>{{parts.quantity}}</span>
                                        </p>
                                        <p>
                                            <span>设计寿命(月):</span>
                                            <span>{{parts.designedLife}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
            <van-tab title="维修信息">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(2)">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
                        <div v-for="repair in list" class="card" :key="repair.uuid" @click="openForm(repair.uuid,repair.workflowTemplateId)">
                            <table class="layout">
                                <tr>
                                    <td class="avatar-box" rowspan="4">
                                        <img :src="avatarUrl + repair.firstExaminerIdavatar" class="avatar" alt="avatar">
                                        <p class="advisor">{{repair.repairingEngineerId}}</p>
                                    </td>
                                    <td colspan="2">
                                        <div class="header">
                                            <span class="title">{{repair.serialNumber}}</span>
                                            <span class="status">{{repair.status}}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="content">
                                        <p>
                                            <span class="iconfont icon-user"></span>
                                            <span>{{repair.repairingEngineerId || '无'}}</span>
                                        </p>
                                        <p>
                                            <span class="iconfont icon-date"></span>
                                            <span>报修时间：{{repair.reportTime}}</span>
                                        </p>
                                        <p>
                                            <span class="iconfont icon-date"></span>
                                            <span>完成时间：{{repair.completeTime || '无'}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
            <van-tab title="维保历史纪录">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(3)">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
                        <div v-for="maintenance in list" class="card" :key="maintenance.uuid" @click="openForm(maintenance.uuid,maintenance.workflowTemplateId)">
                            <table class="layout">
                                <tr>
                                    <td class="avatar-box" rowspan="4">
                                        <img :src="avatarUrl + maintenance.firstExaminerIdavatar" class="avatar" alt="avatar">
                                        <p class="advisor">{{maintenance.repairingEngineerId}}</p>
                                    </td>
                                    <td colspan="2">
                                        <div class="header">
                                            <span class="title">{{maintenance.serialNumber}}</span>
                                            <span class="status">{{maintenance.status}}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="content">
                                        <p>
                                            <span class="iconfont icon-user"></span>
                                            <span>{{maintenance.maintenanceEngineerId || '无'}}</span>
                                        </p>
                                        <p>
                                            <span class="iconfont icon-date"></span>
                                            <span>{{maintenance.maintenanceDate}}</span>
                                        </p>
                                        <p>
                                            <span class="iconfont icon-beizhu"></span>
                                            <span>{{maintenance.remark || '无'}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
            <van-tab title="收款信息" v-if="checkPermission('设备收款信息')">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(4)">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
                        <div v-for="payInfo in list"  class="card" :key="payInfo.uuid" @click="openForm(payInfo.uuid,payInfo.workflowTemplateId)">
                            <table class="layout">
                                <tr>
                                    <td class="avatar-box" rowspan="4">
                                        <img :src="avatarUrl + payInfo.advisorIdavatar" class="avatar" alt="avatar">
                                        <p class="advisor">{{payInfo.advisorIdname}}</p>
                                    </td>
                                    <td colspan="2">
                                        <div class="header">
                                            <span class="title">{{payInfo.serialNumber}}</span>
                                            <span class="status">{{payInfo.amount}}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="content">
                                        <p>
                                            <span class="iconfont icon-file"></span>
                                            <span>{{payInfo.paymentTypename || '无'}}</span>
                                        </p>
                                        <p>
                                            <span class="iconfont icon-date"></span>
                                            <span>{{payInfo.applicationDate}}</span>
                                        </p>
                                        <p>
                                            <span class="iconfont icon-beizhu"></span>
                                            <span>{{payInfo.remark}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
    import {Tab, Tabs, Panel, Field, List, Search, PullRefresh, CellGroup, ImagePreview,Cell} from 'vant';
    import userInfo from '../store/userInfo';
    import equipmentService from "../service/equipmentService";
    import moment from "moment";
    import {formatDictionary} from "../utils/dictionary";
    import {formatMoney} from "../utils/money";
    import {getKey} from "../utils/url";
    import {API_URL} from "../common/config";

    export default {
        data: function () {
            return {
                selected: 0,
                list: [],
                equipmentImage: [],
                examiningImage: [],
                installedImage: [],
                attachmentIds: [],
                reportList: [],
                data:{},
                loading: false,
                finished: false,
                pageIndex: 0,
                value: '',
                equipmentId: '',
                projectId: '',
                refreshing: false
            }
        },
        store: userInfo,
        components: {
            [Tab.name]: Tab,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Tabs.name]: Tabs,
            [Panel.name]: Panel,
            [Field.name]: Field,
            [List.name]: List,
            [Search.name]: Search,
            [PullRefresh.name]: PullRefresh
        },
        computed: {
            userId() {
                return this.$store.getters.getUserId;
            },
            avatarUrl() {
                return API_URL + "/oa/common/attachment/showImage?id=";
            },
            downLoadUrl() {
                return  "/attachment/downloadFile?id=";
            }
        },
        created: async function () {
            this.equipmentId = getKey("equipmentId");
            this.projectId = getKey("projectId");
            let resp = await equipmentService.getEquipment(this.equipmentId);
            if (resp.data.Status === "1"){
                this.data = resp.data.Data;
                this.data.arrivalDate = moment(this.data.arrivalDate).format('YYYY-MM-DD');
                this.data.turnOnDate = moment(this.data.turnOnDate).format('YYYY-MM-DD');
                this.data.outInsuranceDate = moment(this.data.outInsuranceDate).format('YYYY-MM-DD');
                this.equipmentImage = resp.data.Data.equipmentImage!==undefined ? resp.data.Data.equipmentImage.split(','):[];
                this.examiningImage = resp.data.Data.examiningImage!==undefined ? resp.data.Data.examiningImage.split(','):[];
                this.installedImage = resp.data.Data.installedImage!==undefined ? resp.data.Data.installedImage.split(','):[];
                this.attachmentIds = resp.data.Data.attachmentIds!==undefined ? resp.data.Data.attachmentIds.split(','):[];
                this.reportList = resp.data.Data.reportIds!==undefined ? resp.data.Data.reportIds.split(','):[];
            }
        },
        methods: {
            async repairingInfo() {
                this.pageIndex++;
                let resp = await equipmentService.repairingInfo(this.pageIndex, this.value, this.equipmentId);
                if (resp.data.Status === "1"){
                    resp.data.Data.data.forEach(repair => {
                        repair.reportTime = moment(repair.reportTime).format('YYYY-MM-DD');
                        repair.completeTime = repair.completeTime === "" ? "" : moment(repair.completeTime).format('YYYY-MM-DD');
                    });
                    formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                    this.loading = false;
                    this.refreshing = false;
                    this.list = [...this.list, ...resp.data.Data.data];
                    this.finished = resp.data.Data.total <= this.list.length;
                }
            },
            async maintenanceInfo() {
                this.pageIndex++;
                let resp = await equipmentService.maintenanceInfo(this.pageIndex, this.value, this.equipmentId,this.projectId);
                if (resp.data.Status === "1"){
                    resp.data.Data.data.forEach(maintenance => {
                        maintenance.maintenanceDate = moment(maintenance.maintenanceDate).format('YYYY-MM-DD');
                        maintenance.remark = maintenance.remark || '暂无备注';
                    });
                    formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                    this.loading = false;
                    this.refreshing = false;
                    this.list = [...this.list, ...resp.data.Data.data];
                    this.finished = resp.data.Data.total <= this.list.length;
                }
            },
            async partsList() {
                this.pageIndex++;
                let resp = await equipmentService.partsList(this.pageIndex, this.value, this.equipmentId,this.projectId);
                if (resp.data.Status === "1"){
                    resp.data.Data.data.forEach(maintenance => {
                        maintenance.maintenanceDate = moment(maintenance.maintenanceDate).format('YYYY-MM-DD');
                        maintenance.remark = maintenance.remark || '暂无备注';
                    });
                    formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                    this.loading = false;
                    this.refreshing = false;
                    this.list = [...this.list, ...resp.data.Data.data];
                    this.finished = resp.data.Data.total <= this.list.length;
                }
            },
            async payAmountInfo() {
                this.pageIndex++;
                let resp = await equipmentService.getPayAmountInfo(this.pageIndex, this.value, this.equipmentId);
                if (resp.data.Status === "1"){
                    resp.data.Data.data.forEach(payInfo => {
                        payInfo.amount = formatMoney(payInfo.amount === undefined ? "0" : payInfo.amount);
                        payInfo.remark = payInfo.remark || '暂无备注';
                    });
                    formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                    this.loading = false;
                    this.refreshing = false;
                    this.list = [...this.list, ...resp.data.Data.data];
                    this.finished = resp.data.Data.total <= this.list.length;
                }
            },
            onRefresh(index){
                this.list = [];
                this.finished = false;
                this.pageIndex = 0;
                switch (index) {
                    case 1:
                        this.partsList();
                        break;
                    case 2:
                        this.repairingInfo();
                        break;
                    case 3:
                        this.maintenanceInfo();
                        break;
                    case 4:
                        this.payAmountInfo();
                        break;
                }
            },
            openForm(id,workflowTemplate) {
                window.open('/wf/form/vsheet/form?workflowTemplateId='+workflowTemplate+'&id=' + id);
            },
            switchTab(index) {
                window.scrollTo(0, 0);
                this.onRefresh(index)
            },
            showImagePreview(uuid){
                ImagePreview({
                    images:[this.avatarUrl+uuid]
                })
            },
            downLoad(uuid){
                window.open(this.downLoadUrl+uuid);
            }
        }
    };
</script>

<style type="less">
    .van-image-preview {
        top: 20px;
        width: 100%;
        position: fixed;
    }
    .van-image-preview__image {
        max-width: 100%;
    }
    .van-image-preview__overlay{
        background-color: rgba(0, 0, 0, 0.9);
    }
    .van-image-preview__index {
        display: none;
    }
    .attachImg{
       width: 2.5rem;
        padding-left: 0.5rem;
    }
    .attachment-title{
        max-width: 5.5rem
    }
</style>